import { useCallback } from "react";

// Ref для прокручиваемого блока: ставит ему `data-overflow-top` и `data-overflow-bottom`,
// пока за верхним или нижним краем есть содержимое, — по ним блок гасит края. Атрибуты
// меняются прямо в DOM, без перерисовки. Высоту содержимого следят размеры детей: список
// матчей приходит позже и меняет её без прокрутки.
export const useOverflowEdges = () =>
  useCallback((element: HTMLElement | null) => {
    if (element === null) {
      return;
    }
    const update = () => {
      const { scrollTop, scrollHeight, clientHeight } = element;
      element.toggleAttribute("data-overflow-top", scrollTop > 1);
      element.toggleAttribute("data-overflow-bottom", scrollTop + clientHeight < scrollHeight - 1);
    };
    update();
    element.addEventListener("scroll", update, { passive: true });
    if (typeof ResizeObserver === "undefined") {
      return () => {
        element.removeEventListener("scroll", update);
      };
    }
    const resizeObserver = new ResizeObserver(update);
    const observe = () => {
      resizeObserver.disconnect();
      resizeObserver.observe(element);
      for (const child of element.children) {
        resizeObserver.observe(child);
      }
    };
    observe();
    const mutationObserver = new MutationObserver(observe);
    mutationObserver.observe(element, { childList: true });
    return () => {
      element.removeEventListener("scroll", update);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
